import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ExamplePage from 'components_new/pages/TemplatePage'
import TemplatesPage from 'components_new/pages/TemplatesPage'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ExamplePage />}
        path={'/templates/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <TemplatesPage />}
        path={'/templates'}
      />
      <Route path={'/templates/*'}>
        <Redirect to="/templates" />
      </Route>

      {/* Legacy redirects from the former /explore path */}
      <Route
        path={'/explore/:id'}
        render={({ match }) => (
          <Redirect to={`/templates/${match.params.id}`} />
        )}
      />
      <Route path={'/explore'}>
        <Redirect to="/templates" />
      </Route>
    </Switch>
  )
}

export default Routes
